var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewNoCommentImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 167,
    viewBox: "0 0 190 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2672_23559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.704 145.18C144.894 134.467 158.644 113.233 158.644 88.7877C158.644 53.5529 130.085 24.9937 94.85 24.9937C94.5823 24.9937 94.3146 24.9937 94.047 24.9937C94.047 24.9937 96.0736 33.3407 93.6755 42.4034C91.2774 51.4662 85.7818 52.5205 81.4116 51.122L83.7606 62.5228L99.9959 60.5289L116.138 92.7591L113.249 111.66L122.399 146.338L124.704 145.174V145.18Z",
    fill: "#F9F8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4764 132.594C37.6765 121.166 31.0557 105.75 31.0557 88.7879C31.0557 66.2595 42.735 46.457 60.3633 35.1108C60.3633 35.1108 61.3903 38.1317 64.1982 39.847L72.7255 46.7847L77.123 63.2276L71.5347 64.0307L60.4617 92.1693L50.2299 134.375L48.4764 132.594V132.594Z",
    fill: "#F9F8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.693 105.477C125.403 99.1455 121.677 94.3383 121.677 94.3383L100.001 60.5293L90.8618 61.6546L87.4913 85.5924L71.5401 64.0309L53.3983 66.2597C53.3983 66.2597 54.398 74.3282 54.7913 82.3803L50.2354 134.375C50.2354 134.375 79.8271 165.594 122.404 146.344L113.254 111.666C113.254 111.666 119.989 111.808 122.699 105.477H122.693ZM79.4502 104.029C79.4502 104.029 75.6699 109.06 72.1082 110.475C68.5465 111.89 66.2358 109.383 67.0716 103.177C67.9128 96.9713 73.3209 91.1316 73.3209 91.1316L88.5784 98.7576L79.4502 104.035V104.029ZM107.72 96.9003C108.162 93.1692 105.77 91.4157 105.77 91.4157C112.642 88.5368 115.018 94.3437 115.018 94.3437L107.72 96.9058V96.9003Z",
    fill: "#D7D4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0713 108.203C34.0713 108.203 40.9052 132.348 63.9143 144.432",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.276 139.296C161.408 135.451 165.68 118.969 162.249 106.372C158.819 93.7752 152.378 97.0911 151.597 99.2107C150.816 101.33 151.466 105.837 154.367 109.382C157.267 112.928 164.538 118.642 175.901 115.113C191.846 110.158 197.38 81.5769 173.983 71.7057C143.228 58.7371 117.651 85.5866 117.651 85.5866",
    stroke: "#EA5599",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8135 33.4447L71.7094 32.8547C72.0535 32.6253 72.1518 32.1664 71.9224 31.8223C71.4362 31.0957 70.6113 29.812 69.9012 28.4681C68.8141 26.4087 69.1473 24.6934 71.1685 23.0545C72.6817 21.8254 74.692 19.0394 71.7585 15.7891C71.7585 15.7891 75.2328 16.8762 77.265 14.2595C79.2971 11.6374 80.4334 10.381 84.8746 11.1348C89.3158 11.8887 92.4733 10.9054 94.2869 6.90119C96.106 2.89699 98.1272 2.17045 99.9791 2.40535C101.591 2.61293 101.47 1.24724 100.039 0.755594C98.8155 0.334962 96.1606 -0.664722 92.7136 1.82083C90.1844 3.64539 88.1632 2.25239 87.2126 1.48214C86.2621 0.711892 83.7984 -1.02526 80.4607 0.853924C79.2917 1.50945 75.8611 -0.932396 72.5288 1.05605C69.1965 3.04449 70.4639 4.95099 66.0827 6.33306C61.7016 7.71514 62.002 12.6808 63.3295 13.9918C63.3295 13.9918 58.9101 13.9099 58.5441 17.8868C58.2874 20.6728 60.8767 21.1644 59.2925 24.2618C58.3529 26.0973 57.4625 29.5334 60.0464 31.052C60.0464 31.052 61.0788 27.2336 64.1653 27.9437C66.8803 28.5719 68.7595 31.0957 69.7318 33.1388C69.9285 33.5485 70.4365 33.7015 70.8189 33.4502L70.8135 33.4447Z",
    fill: "#0E090C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7001 28.8395C64.4604 26.8292 60.8495 26.9494 60.0411 31.041C59.2326 35.1326 61.9913 38.8145 65.0395 40.3222C68.0877 41.8299 70.1526 40.6336 70.6333 38.962C70.6333 38.962 75.6317 51.4662 84.5251 51.7339C94.7131 52.0398 99.0943 30.3745 89.5727 12.0688",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6392 38.9678L77.1289 63.2333",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.417 51.1279L83.2088 60.95",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.925 39.667C63.8157 41.7592 64.4712 43.7258 66.8202 44.2939C68.2842 44.649 68.612 45.3701 69.1037 46.3643C69.5953 47.3586 71.3871 48.1889 72.8019 47.0636L70.7753 39.4922C70.7753 39.4922 69.3604 41.3714 67.5905 41.0163C65.8205 40.6612 63.925 39.667 63.925 39.667V39.667Z",
    fill: "#0E090C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.854 38.2905C81.854 38.2905 84.7329 42.546 89.6603 40.1697",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7383 20.3779L92.2881 33.8491L88.1528 36.3893",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2617 19.7496C88.2617 19.7496 91.086 23.2185 91.2935 19.1597",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5206 21.7764C82.5206 21.7764 84.7167 27.4631 78.1777 25.054",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9077 105.476L73.8017 94.8623",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6235 109.044L75.5773 97.3096",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3828 110.694L77.2765 101.56",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3215 91.1313L66.0615 76.7588",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.796 96.9004L117.651 93.4097",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.006 69.1274L107.485 89.8641",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.378 110.699C115.537 111.535 113.45 111.862 111.347 111.568L101.416 110.164",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4503 104.029L103.344 90.214C103.344 90.214 108.818 91.4158 107.66 97.9985C106.502 104.581 99.5915 113.491 93.5715 118.156C86.0329 123.996 73.7363 128.65 64.8702 115.55C55.0427 101.019 53.3984 66.2544 53.3984 66.2544",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7305 63.7631L81.127 70.0944L81.8044 62.7688L86.7591 69.3569L87.6332 62.0532",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5723 121.603L93.5662 160.137",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5308 81.5825L89.8733 88.7988L90.3377 97.7359",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3276 88.9576L72.8352 82.6263L78.3635 75.9562L70.0547 76.7101L71.0216 66.2544",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2328 63.3589L97.6245 71.624L92.5442 73.9402L98.5259 76.6388L90.0859 86.521",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8867 62.8726L87.4915 85.5921",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7318 92.7648C88.305 92.7648 88.7697 92.3001 88.7697 91.7269C88.7697 91.1537 88.305 90.689 87.7318 90.689C87.1585 90.689 86.6938 91.1537 86.6938 91.7269C86.6938 92.3001 87.1585 92.7648 87.7318 92.7648Z",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.409 128.551C89.9822 128.551 90.4469 128.087 90.4469 127.514C90.4469 126.94 89.9822 126.476 89.409 126.476C88.8358 126.476 88.3711 126.94 88.3711 127.514C88.3711 128.087 88.8358 128.551 89.409 128.551Z",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0863 144.71C90.6595 144.71 91.1242 144.245 91.1242 143.672C91.1242 143.099 90.6595 142.634 90.0863 142.634C89.513 142.634 89.0483 143.099 89.0483 143.672C89.0483 144.245 89.513 144.71 90.0863 144.71Z",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7305 63.7631L87.6332 62.0532",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.783 166.993C143.844 166.993 152.81 158.027 152.81 146.966C152.81 135.906 143.844 126.94 132.783 126.94C121.723 126.94 112.757 135.906 112.757 146.966C112.757 158.027 121.723 166.993 132.783 166.993Z",
    fill: "#FFF7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4492 133.118C19.4967 133.118 23.5884 129.026 23.5884 123.979C23.5884 118.932 19.4967 114.84 14.4492 114.84C9.40181 114.84 5.31006 118.932 5.31006 123.979C5.31006 129.026 9.40181 133.118 14.4492 133.118Z",
    fill: "#FFF7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.87 154.62C174.441 154.62 178.146 150.914 178.146 146.343C178.146 141.773 174.441 138.067 169.87 138.067C165.299 138.067 161.594 141.773 161.594 146.343C161.594 150.914 165.299 154.62 169.87 154.62Z",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6385 81.0035C42.9363 81.0035 47.2311 76.7088 47.2311 71.411C47.2311 66.1131 42.9363 61.8184 37.6385 61.8184C32.3407 61.8184 28.0459 66.1131 28.0459 71.411C28.0459 76.7088 32.3407 81.0035 37.6385 81.0035Z",
    stroke: "#0E090C",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7844 128.016C37.5672 130.004 32.8091 131.004 27.8271 130.736C11.7666 129.873 -0.546448 116.151 0.316667 100.096C1.10877 85.4283 12.6188 73.8855 26.8438 72.6509",
    stroke: "#EA5599",
    strokeWidth: 0.546089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2672_23559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 166.985,
    fill: "white",
    transform: "translate(0 0.00732422)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNoCommentImage);
export default __webpack_public_path__ + "static/media/NewNoCommentImage.9ff63c9c6ffabd93f243a744c8d49650.svg";
export { ForwardRef as ReactComponent };